$(document).ready(() => {
  waitForFbq(() => {
    const $fbPixelElements = $("[data-fb-pixel-id]")

    if ($fbPixelElements.length > 0) {
      const alreadySentIds = []

      $(window).scroll(() => {
        const topOfScreen = $(window).scrollTop()

        $fbPixelElements.each(function () {
          const $element = $(this)
          const fbPixelId = $element.data("fb-pixel-id")

          if (
            alreadySentIds.indexOf(fbPixelId) === -1 &&
            topOfScreen > $element.offset().top - 150
          ) {
            alreadySentIds.push(fbPixelId)

            fbq("track", "ViewContent", {
              content_ids: [fbPixelId],
              content_type: "product",
            })
          }
        })
      })
    }
  })
})

function waitForFbq(callback) {
  if (typeof fbq !== "undefined") {
    callback()
  } else {
    setTimeout(() => {
      waitForFbq(callback)
    }, 100)
  }
}

window.waitForFbq = waitForFbq
